import { vnDate } from '../../app/lib/coach';

// Labels shared by Người dùng and the user page: plans, how they sign in, what they came for.
export const TIERS = [
  { id: '', label: 'Tất cả', count: 'all' },
  { id: 'free', label: 'Miễn phí' },
  { id: 'trial', label: 'Dùng thử' },
  { id: 'pro', label: 'Pro' },
  { id: 'gift', label: 'HLV tặng Pro' },
  { id: 'unlimited', label: 'Không giới hạn' },
];
export const TIER_STYLES = {
  free: 'bg-base-200 text-muted',
  trial: 'bg-[#fdf3d7] text-[#8a5a00]',
  pro: 'bg-[#e3f1e9] text-[#17804f]',
  gift: 'bg-[#ece7fb] text-[#5b44b0]',
  unlimited: 'bg-[#15261f] text-[#6fd3a0]',
};
export const SIGN_IN = { google: 'Google', apple: 'Apple', zalo: 'Zalo', password: 'Mật khẩu' };
export const ROLES = { self: 'Dùng cho mình', coach: 'Huấn luyện viên', student: 'Học viên', existing: 'Tài khoản cũ' };

export function planText(plan) {
  switch (plan.tier) {
    case 'pro': {
      const bought = plan.pro_until && new Date(plan.pro_until) > new Date();
      const given = plan.admin_pro_until && new Date(plan.admin_pro_until) > new Date();
      return [bought && `Pro đến ${vnDate(plan.pro_until)}`, given && `Pro quản trị tặng đến ${vnDate(plan.admin_pro_until)}`].filter(Boolean).join(' · ');
    }
    case 'trial': return `Dùng thử đến ${vnDate(plan.trial_ends_at)}`;
    case 'gift': return `HLV ${plan.gift.coach_name} tặng${plan.gift.until_cancelled ? ' · đến khi dừng' : plan.gift.ends_at ? ` · đến ${vnDate(plan.gift.ends_at)}` : ''}`;
    case 'unlimited': return 'Không giới hạn';
    default: return plan.trial_ends_at ? `Miễn phí · đã dùng thử (hết ${vnDate(plan.trial_ends_at)})` : 'Miễn phí';
  }
}
